import * as React from 'react';
import clsx from 'clsx';
import { Button, Typography } from '@/components/common';
import { CaseDetailsErrorStateProps } from '@/interfaces';

export const CaseDetailsErrorState: React.FC<CaseDetailsErrorStateProps> = ({
	message,
	onRetry,
	className,
}) => {
	const [isRetrying, setIsRetrying] = React.useState(false);

	const handleRetry = async (): Promise<void> => {
		setIsRetrying(true);
		try {
			await onRetry();
		} finally {
			setIsRetrying(false);
		}
	};

	return (
		<div
			role="alert"
			className={clsx(
				'flex flex-col items-center justify-center gap-3 px-6 py-10 text-center',
				className
			)}
		>
			<Typography type="regular-14" className="text-main-red">
				{message}
			</Typography>
			<Button
				type="button"
				decoration="primary"
				size="fit"
				label="Retry"
				loading={isRetrying}
				disabled={isRetrying}
				onClick={handleRetry}
			/>
		</div>
	);
};
